import React from 'react';


import classes from './CalcWarning.css';


const CalcWarning = props => {
    return (
        <div className={classes.CalcWarningWrapper}>
            <div className={classes.CalcWarningHelper}>
                <p>*Stay on this page</p>
            </div>
        </div>
    )
}


export default CalcWarning;


// WEBPACK FOOTER //
// ./src/components/UI/CalcWarning/CalcWarning.js